




















import DotTypeEditor from "./DotTypeEditor.vue";
import { BaseCont } from "@/models/continuity/BaseCont";
import Vue from "vue";
import StuntSheet from "@/models/StuntSheet";
import { Mutations } from "@/store/mutations";

export default Vue.extend({
  name: "DotTypeEditorWrapper",
  components: {
    DotTypeEditor,
  },
  computed: {
    dotTypes(): BaseCont[][] {
      const selectedSS = this.$store.getters
        .getSelectedStuntSheet as StuntSheet;
      return selectedSS.dotTypes;
    },
  },
  methods: {
    addDotType() {
      this.$store.commit(Mutations.ADD_DOT_TYPE);
    },
  },
});
